<template>
  <div class="pa-4">
    <div v-if="loading">
      <v-skeleton-loader type="card"></v-skeleton-loader>
    </div>
    <div v-else-if="!loading && productsPackage">
      <v-card elevation="0" class="pa-2">
        <v-card-text>
          <v-text-field outlined dense :label="$t('message.name')" v-model="productsPackage.name"></v-text-field>
          <v-text-field outlined dense :label="$t('message.description')"
            v-model="productsPackage.description"></v-text-field>
          <v-autocomplete return-object @change="selectMainPackageProduct" v-model="productsPackage.mainProduct"
            :items="availableProductsForMain" item-text="name" :label="$t('message.main_product')" item-value="_id"
            clearable outlined dense></v-autocomplete>
          <div v-if="taxBehavior" class="text-caption text-center">
            {{ $t('message.package_tax_enabled') }}
          </div>
          <v-select @change="updateProductsDisplay" outlined multiple :label="$t('message.add_more_products')" dense
            :items="availableProductsForExtra" v-model="productsPackage.products"></v-select>
          <v-text-field disabled outlined dense :label="'Total (' + currencySymbol + ')'"
            v-model="productsPackage.amountDecimal"></v-text-field>
          <div v-if="productsPackage.products && productsPackage.products.length > 0">
            <v-list dense v-if="products">
              <v-subheader>{{ $t('message.products') }} ({{ products.length }})</v-subheader>
              <template v-for="(i, index) in products">
                <v-list-item dense :key="'product_package_' + index" class="text-left">
                  <v-list-item-avatar>
                    <v-avatar size="35">
                      <ImageDisplay v-if="i.image" :src="i.image" />
                      <img v-else :src="assets('logo-circular-watermarked.png')" />
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ i.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ currencySymbol + i.amountDecimal }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action v-if="index == 0">
                    <v-icon color="secondary">mdi-star</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index + 1 < products.length" :key="index"></v-divider>
              </template>
            </v-list>
          </div>
          <v-text-field disabled outlined dense label="Total" v-model="productsPackage.amountDecimal"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="updating" color="primary" outlined @click="updateProductsPackage()">{{ $t('message.update')
            }}</v-btn>
          <v-btn :loading="updating" color="primary" outlined @click="navigateTo({
            name: 'sellproduct',
            params: { productId: 'package' },
            query: { packageId: productsPackage._id }
          })">{{ $t('message.sell')
            }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="error" @click="archivePackageDialog = true">{{ $t('message.archive') }}</v-btn>
          <v-btn elevation="0" @click="goBack()">{{ $t('message.back') }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="archivePackageDialog" width="70%">
        <v-card outlined>
          <v-card-title>
            {{ $t('message.are_you_sure') }}
          </v-card-title>
          <v-card-actions>
            <v-btn elevation="0" :loading="updating" outlined olor="error" @click="archive()">
              {{ $t("message.archive") }}
            </v-btn>
            <v-btn elevation="0" @click="archivePackageDialog = false;">
              {{
                $t("message.cancel")
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      loading: true,
      packageId: this.$route.params.packageId,
      productsPackage: null,
      subscriptions: [],
      availableProductsForMain: [],
      availableProductsForExtra: [],
      currencySymbol: '$',
      updating: false,
      archivePackageDialog: false,
      taxBehavior: null,
    };
  },
  components: {
  },
  created() {
    this.loading = true;
    this.initPage();
  },
  methods: {
    calculateTotal() {
      let total = 0;
      if (this.productsPackage) {
        if (this.products) {
          for (const p of this.products)
            total += p.amountDecimal;
        }
      }
      this.productsPackage.amountDecimal = total;
    },
    archive() {
      this.updating = true;
      Api()
        .delete("admins/managedacademy/" + this.$store.state.managedAcademy + "/products/packages/" + this.packageId)
        .then(() => {
          this.showAlert("success", this.$t("message.updated"));
          this.updating = false;
          this.navigateTo({
            name: "productstabs",
            params: { tabId: 2 },
          });
        })
        .catch((e) => {
          if (e) {
            this.showAlert("error", this.$t("message.error_generic"));
          }
        });
    },
    updateProductsDisplay() {
      this.products = [];
      this.products.push(this.productsPackage.mainProductObject);
      if (this.productsPackage.products) {
        for (const p of this.productsPackage.products) {
          for (const p2 of this.availableProductsForExtra) {
            if (p == p2._id) {
              this.products.push(p2);
              break;
            }
          }
        }
        this.calculateTotal();
      }
    },
    updateProductsPackage() {
      this.updating = true;
      Api()
        .patch("admins/managedacademy/" + this.$store.state.managedAcademy + "/products/packages/" + this.packageId, this.productsPackage)
        .then(() => {
          this.showAlert("success", this.$t("message.updated"));
          this.updating = false;
        })
        .catch((e) => {
          if (e) {
            this.showAlert("error", this.$t("message.error_generic"));
          }
        });
    },
    selectMainPackageProduct(e) {
      if (e) {
        this.productsPackage.mainProduct = e._id;
        this.productsPackage.mainProductObject = e;
        this.taxBehavior = e.taxBehavior;
        this.productsPackage.products = [];
        this.fillAvalableExtraProducts();
        this.calculateTotal();
      } else {
        this.productsPackage.products = [];
      }
    },
    fillAvalableExtraProducts() {
      if (this.productsPackage && this.productsPackage.mainProductObject) {
        this.availableProductsForExtra = [];
        for (const i of this.availableProductsForMain) {
          //Add products to our lists for packages
          let taxMatches = false;
          if (i.name) {
            if (this.productsPackage.mainProductObject.taxBehavior && i.taxBehavior == this.productsPackage.mainProductObject.taxBehavior) {
              taxMatches = true;
            } else if (!this.productsPackage.mainProductObject.taxBehavior && !i.taxBehavior) {
              taxMatches = true;
            }
            if (taxMatches && !i.subscription && i.name && i.amountDecimal) {
              this.availableProductsForExtra.push({ text: i.name, value: i._id, product: i, _id: i._id, name: i.name, taxBehavior: i.taxBehavior, amountDecimal: i.amountDecimal })
            }
          }
        }
      }
    },
    initPage() {
      this.loading = true;
      if (this.$store.state.managedAcademy) {
        Api()
          .get("admins/academy/" + this.$store.state.selectedAcademy)
          .then((response) => {
            if (response.data.currencySymbol)
              this.currencySymbol = response.data.currencySymbol;
          });
        Api()
          .get(
            "admins/academy/" + this.$store.state.managedAcademy + "/products"
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              this.subscriptions = data.subscriptions;
              this.availableProductsForMain.push({ header: this.$t("message.memberships") });
              for (const i of this.subscriptions) {
                this.availableProductsForMain.push({ taxBehavior: i.taxBehavior, name: i.name, amountDecimal: i.amountDecimal, _id: i._id, image: i.image, subscription: true })
              }
              this.availableProductsForMain.push({ header: this.$t("message.goods") });
              for (const g of data.goods) {
                this.availableProductsForMain.push({ taxBehavior: g.taxBehavior, name: g.name, amountDecimal: g.amountDecimal, _id: g._id, image: g.image })
              }

              Api()
                .get("admins/managedacademy/" + this.$store.state.managedAcademy + "/products/packages/" + this.packageId)
                .then((response) => {
                  const productsPackage = response.data.data;
                  const mainProductObject = productsPackage.mainProduct;
                  productsPackage.mainProductObject = mainProductObject;
                  productsPackage.mainProduct = mainProductObject._id;
                  this.products = [];
                  this.products.push(mainProductObject);
                  const productIds = [];
                  if (productsPackage.products) {
                    for (const p of productsPackage.products) {
                      this.products.push(p);
                      productIds.push(p._id);
                    }
                  }
                  this.productsPackage = productsPackage;
                  this.fillAvalableExtraProducts();
                  this.productsPackage.products = productIds;
                  this.loading = false;
                  this.calculateTotal();
                })
                .catch((e) => {
                  if (e) {
                    this.showAlert("error", this.$t("message.error_generic"));
                  }
                });
            }
          })
          .catch((e) => {
            this.loading = false;
            if (e)
              this.showAlert(
                "error",
                this.$t("message.error_generic")
              );
          });
      }
    },
  },
};
</script>

<style scoped></style>